import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Brands/idc0fO79Qg.jpeg")